const types = {
    SET_LIST_CREDIT_HISTORY: '[CREDIT MOBILE] SET LIST CREDIT HISTORY',
    SET_LIST_CREDIT: '[CREDIT MOBILE] SET LIST CREDIT',
    SET_LIST_GROUPS: '[CREDIT MOBILE] SET LIST GROUPS',
    SET_CREDIT_LIVE: '[CREDIT MOBILE] SET CREDIT LIVE'
}

export {
    types
}